import { FormInitializerReturnType, stringSchema } from 'src/Configuration/validation'
import { InstallationLocationChangeForm } from '../../models'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { boolean, object, string } from 'yup'

const MIN_STRING_LENGTH_NUMBER = 1
const MIN_STRING_LENGTH_STRING = 3
const MAX_STRING_LENGTH = 50
const MAX_LENGTH_ZIP = 10
const MAX_LENGTH_REASON = 1000

/**
 *  Initializes the form for changing the installation location
 * @returns initialValues and validationSchema for location change form
 */
export const useChangeLocationFormInitializer = (): FormInitializerReturnType<InstallationLocationChangeForm, InstallationLocationChangeForm> => {
  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)
  const initialValues: InstallationLocationChangeForm = {
    streetName: '',
    streetNumber: '',
    zip: '',
    city: '',
    countryCode: '',
    reason: '',
    reReleaseInstallationStatement: false,
  }

  const validationSchema = object().shape({
    streetName: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH_STRING, maxLength: MAX_STRING_LENGTH }).required().trim(),
    streetNumber: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH_NUMBER, maxLength: MAX_STRING_LENGTH }).required().trim(),
    city: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH_STRING, maxLength: MAX_STRING_LENGTH }).required().trim(),
    zip: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH_NUMBER, maxLength: MAX_LENGTH_ZIP }).required().trim(),
    countryCode: string().required(),
    reason: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH_STRING, maxLength: MAX_LENGTH_REASON }).required(),
    reReleaseInstallationStatement: boolean().required(),
  })
  return { initialValues, validationSchema }
}
